module.exports = __webpack_public_path__ + "img/FacebookIcon.png";